import React from 'react';
import Error404 from '../../../../assets/icons/404.svg';
import CommonErrorPage from '../CommonErrorPage/CommonErrorPage';
import { NOT_FOUND_DESCRIPTION } from '../helpers/constants';
import { useStyles } from './NotFound.styles';
import theme from '../../../../styles/theme';

const NotFoundPage = () => {
  const { classes } = useStyles(theme);

  return (
    <CommonErrorPage
      errorImage={Error404}
      title="Page not found"
      description={NOT_FOUND_DESCRIPTION}
      buttonText="Go to home page"
    />
  );
};

export default NotFoundPage;
